import { atom } from "jotai";

import { $accessTokenFunc, $isAuthenticated } from "../authenication";
import { $docsApi } from "../docsapi/docsapi.atom";
import { $workspaceOverrides } from "./workspace.atom";
import type { Workspace } from "./workspace.types";

type UploadAvatarInput = {
	workspace: Workspace;
	file: File;
};

export const $uploadWorkspaceAvatar = atom(
	null,
	async (get, set, { workspace, file }: UploadAvatarInput) => {
		if (!workspace) {
			return;
		}

		if (!get($isAuthenticated)) {
			return;
		}

		const accessTokenFunc = get($accessTokenFunc);
		const token = await accessTokenFunc.getAccessTokenSilently?.();
		if (!token) {
			return;
		}

		const docsApi = get($docsApi);
		const result = await docsApi.workspaces.uploadAvatar(workspace, file, token);

		// Optimistically update the workspace avatarUrl
		const currentOverrides = get($workspaceOverrides) ?? {};
		set($workspaceOverrides, {
			...currentOverrides,
			[workspace.id]: { ...currentOverrides[workspace.id], avatarUrl: result.avatar_url },
		});

		return result.avatar_url;
	}
);
$uploadWorkspaceAvatar.debugLabel = "uploadWorkspaceAvatar";

export const $deleteWorkspaceAvatar = atom(null, async (get, set, workspace: Workspace) => {
	if (!workspace) {
		return false;
	}

	if (!get($isAuthenticated)) {
		return false;
	}

	const accessTokenFunc = get($accessTokenFunc);
	const token = await accessTokenFunc.getAccessTokenSilently?.();
	if (!token) {
		return false;
	}

	const docsApi = get($docsApi);
	await docsApi.workspaces.deleteAvatar(workspace, token);

	// Optimistically clear the workspace avatarUrl
	const currentOverrides = get($workspaceOverrides) ?? {};
	set($workspaceOverrides, {
		...currentOverrides,
		[workspace.id]: { ...currentOverrides[workspace.id], avatarUrl: null },
	});

	return true;
});
$deleteWorkspaceAvatar.debugLabel = "deleteWorkspaceAvatar";
